import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { OrderDetail } from 'Core/models/OrderDetail';
import { HttpParams } from '@angular/common/http';
import { DesignProjectDetailModel } from 'Core/models/DesignProjectDetailModel';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private apiService: ApiService) {}

  getOrdersList(limit: number = 7) {
    return this.apiService.get(
      '/api/orders-requests',
      new HttpParams().set('limit', limit),
    );
  }

  getOrdersById(orderId) {
    return this.apiService.getT<OrderDetail>(`/api/orders/${orderId}`);
  }

  getWorksList(orderId) {
    return this.apiService.get(`/api/orders/${orderId}/estimates/works`);
  }

  updateWorksList(orderId, data) {
    return this.apiService.put(`/api/orders/${orderId}/estimates/works`, data);
  }

  deleteWorksList(orderId, data) {
    return this.apiService.delete2(
      `/api/orders/${orderId}/estimates/works`,
      data,
    );
  }

  getRoomsList(orderId) {
    return this.apiService.get(`/api/orders/${orderId}/estimates/rooms`);
  }

  getMaterialsList(orderId) {
    return this.apiService.get(`/api/orders/${orderId}/estimates/materials`);
  }

  updateMatrialsList(orderId, data) {
    return this.apiService.put(
      `/api/orders/${orderId}/estimates/materials`,
      data,
    );
  }

  getDisabledDate(orderId) {
    return this.apiService.get(
      `/api/orders/${orderId}/measurements/unavailable-date-times`,
    );
  }

  getDisabledDateMain() {
    return this.apiService.get(`/api/measurements/unavailable-date-times`);
  }

  getMeasurementsInfo(orderId) {
    return this.apiService.get(`/api/orders/${orderId}/measurements`);
  }

  postMeasurementsorderId(orderId, data) {
    return this.apiService.post(`/api/orders/${orderId}/measurements`, data);
  }

  postMeasurementsorder(data) {
    return this.apiService.post(`/api/measurements`, data);
  }

  postService(data) {
    return this.apiService.post(`/api/services/requests`, data);
  }

  getAllMeasurements() {
    return this.apiService.get(`/api/measurements`);
  }

  deleteMaterialsList(orderId, data) {
    return this.apiService.delete2(
      `/api/orders/${orderId}/estimates/materials`,
      data,
    );
  }

  getShedulerList(orderId) {
    return this.apiService.get(`/api/orders/${orderId}/estimates/plan`);
  }

  getContract(orderId) {
    return this.apiService.get2(`/api/orders/${orderId}/contracts`);
  }

  getReglament() {
    return this.apiService.get2(`/api/account/userProfile/regulation-contract`);
  }

  writeReglament() {
    return this.apiService.post(
      `/api/account/userProfile/regulation-contract/sign`,
    );
  }

  getDetailsContract(orderId) {
    return this.apiService.get(`/api/orders/${orderId}/details`);
  }

  getDetailsContractGuarantee(orderId) {
    return this.apiService.get(`/api/orders/${orderId}/details/guarantees`);
  }

  updateContract(orderId, data) {
    return this.apiService.put(`/api/orders/${orderId}/details`, data);
  }

  getInstruction(orderId) {
    return this.apiService.get(`/api/orders/${orderId}/instruction-steps`);
  }

  getPriceList() {
    return this.apiService.get(`/api/prices`);
  }

  getProjectsList(orderId) {
    return this.apiService.get(`/api/orders/${orderId}/projects`);
  }

  contractWrite(orderId) {
    return this.apiService.post(`/api/orders/${orderId}/contracts/sign`);
  }

  getInvoeces(orderId) {
    return this.apiService.get(`/api/orders/${orderId}/invoices`);
  }

  getInvoeceById(orderId, invoceId) {
    return this.apiService.get(`/api/orders/${orderId}/invoices/${invoceId}`);
  }

  postInvoeceById(orderId, invoceId, returnUrl, failUrl) {
    return this.apiService.post2(
      `/api/orders/${orderId}/invoices/${invoceId}/pay?returnUrl=${returnUrl}&failUrl=${failUrl}`,
    );
  }

  getCurrentProject(orderId, projectId) {
    return this.apiService.get(`/api/orders/${orderId}/projects/${projectId}`);
  }

  getActs(orderId) {
    return this.apiService.get(`/api/orders/${orderId}/acts`);
  }

  getActsDetails(orderId, actId) {
    return this.apiService.get(`/api/orders/${orderId}/acts/${actId}`);
  }

  getCurrentActs(orderId, actId) {
    return this.apiService.get(`/api/orders/${orderId}/acts/${actId}`);
  }

  writeActs(orderId, actId) {
    return this.apiService.post(`/api/orders/${orderId}/acts/${actId}/sign`);
  }

  correcteActs(orderId, actId, data) {
    return this.apiService.post2(
      `/api/orders/${orderId}/acts/${actId}/complaints`,
      data,
    );
  }

  correctProject(orderId, projectId, data) {
    return this.apiService.post2(
      `/api/orders/${orderId}/projects/${projectId}/corrections`,
      data,
    );
  }

  correctProjectPay(orderId, projectId) {
    return this.apiService.post(
      `/api/orders/${orderId}/projects/${projectId}/corrections/buy`,
    );
  }

  selectProject(orderId, projectId) {
    return this.apiService.post(
      `/api/orders/${orderId}/projects/${projectId}/select`,
    );
  }

  getUserProfile() {
    return this.apiService.get(`/api/account/userProfile`);
  }

  getServices() {
    return this.apiService.get(`/api/services`);
  }

  getServiceDetail(id: number) {
    return this.apiService.get(`/api/services/${id}`);
  }

  getUnreadCount() {
    return this.apiService.get(`/api/messenger/unreadCount`);
  }

  getDesignProjectList(
    pagination: { pageNumber: number; pageSize: number } = {
      pageNumber: 1,
      pageSize: 10,
    },
    tagsId: number[] = [],
  ) {
    return this.apiService.post(`/api/designPortalProjects`, {
      pagination: pagination,
      tagsId: tagsId,
    });
  }

  getDesignProjectDetail(designProjectId: number) {
    return this.apiService.getT<DesignProjectDetailModel>(
      `/api/designPortalProjects/` + designProjectId,
    );
  }

  getMyProfile() {
    return this.apiService.get(`/api/account/userProfile`);
  }

  updateMyProfile(data) {
    return this.apiService.put(`/api/account/userProfile`, data);
  }

  updatePhotoProfile(file: File) {
    let form = new FormData();
    form.append('photo', file);
    return this.apiService.put2(`/api/account/userProfile/avatar`, form);
  }

  getMyBankInfo() {
    return this.apiService.get(`/api/account/userProfile/bankinfo`);
  }
  updateMyBankInfo(data: any) {
    return this.apiService.put(`/api/account/userProfile/bankinfo`, data);
  }

  getCodeForUpdateBankInfo(): Observable<{
    code: string;
    debugMode: boolean;
    login: string;
  }> {
    return this.apiService.get(`/api/account/userProfile/bankinfo/sendcode`);
  }

  sendPhoneUpdateCode(phone: string) {
    return this.apiService.get(`/api/account/SendUpdateCode?phone=${phone}`);
  }

  sendEmailUpdateCode(email: string) {
    return this.apiService.get(`/api/account/SendUpdateCode?email=${email}`);
  }

  updatePhone(data) {
    return this.apiService.post(`/api/account/UpdatePhone`, data);
  }

  updateEmail(data) {
    return this.apiService.post(`/api/account/UpdateEmail`, data);
  }

  sendFeedback(orderId: number, feedback: { text: string; rating: number }) {
    return this.apiService.post(`/api/orders/${orderId}/feedback`, feedback);
  }

  agreeProject(orderId: number, projectId: number) {
    return this.apiService.post(
      `/api/orders/${orderId}/projects/${projectId}/agree`,
    );
  }
}
